import { BugReportButton } from "@/components/common/BugReportButton";
import { DevLoginModal } from "@/components/dev/DevLoginModal";
import { DuplicateLeadModal } from "@/components/lead/sections/DuplicateLeadModal";
import { GhlLocationMismatchModal } from "@/components/lead/sections/GhlLocationMismatchModal";
import { LeadMergeConflictModal } from "@/components/lead/LeadMergeConflictModal";
import { useSidebarBreakpoint } from "@/components/shell/Sidebar/useSidebarBreakpoint";
import type { LeadWorkspaceShellModel } from "@/components/lead/useLeadWorkspaceShellProps";
import { speak } from "@/lib/speech/speak";

export function LeadWorkspaceShellModals(props: { model: LeadWorkspaceShellModel }) {
  const m = props.model;
  // On mobile (<=767px) the floating bug-report pill is replaced by an
  // entry inside the sidebar drawer (see Sidebar.tsx mobile variant) so
  // the bottom-right region is free for `MobileBottomTabBar`. Dev-sync
  // note 3b7f7c31 / docs/planning/bug_report_placement_v2.md.
  const isMobileVariant = useSidebarBreakpoint() === "mobile";

  return (
    <>
      <GhlLocationMismatchModal
        lead={m.pendingLocationSend}
        workspaceLocation={m.location}
        originLocation={m.pendingLocationSend ? m.resolveOrgLocationForOrigin(m.pendingLocationSend) : null}
        onSendWithOrigin={() => m.completeGhlSendUsingOriginLocation()}
        onSendWithCurrentWorkspace={() => m.completeGhlSendUsingWorkspaceLocation()}
        onCancel={() => m.setPendingLocationSend(null)}
      />

      <DuplicateLeadModal
        pendingSendLead={m.pendingSendLead}
        duplicateMatches={m.duplicateMatches}
        duplicateReason={m.duplicateReason}
        canSpeakHelp={m.canSpeakHelp}
        speak={speak}
        sendToGHL={m.handleSendClick}
        setPendingSendLead={m.setPendingSendLead}
        setDuplicateMatches={m.setDuplicateMatches}
        setDuplicateReason={m.setDuplicateReason}
        setCurrentLead={m.setCurrentLead}
        currentLeadRef={m.currentLeadRef}
        setTranscript={m.setTranscript}
        transcriptRef={m.transcriptRef}
        setIsListening={m.setIsListening}
        listeningRef={m.listeningRef}
        setMergeSuggestion={m.setMergeSuggestion}
        findMergeSuggestionForCurrent={m.findMergeSuggestionForCurrent}
      />

      {isMobileVariant ? null : (
        <BugReportButton
          mode={m.mode}
          devMode={m.devMode}
          requestDevMode={m.requestDevMode}
          disableDevMode={m.disableDevMode}
          getSessionInfo={m.getSessionInfo}
        />
      )}
      {/* DevViewportToggle was removed per dev sync note c238ce65 — the
          mobile viewport simulator is now an axis inside the impersonation
          popover (DevImpersonationViewportAxis). */}
      <DevLoginModal
        open={m.devLoginOpen}
        busy={m.devLoginBusy}
        password={m.devLoginPassword}
        error={m.devLoginError}
        onPasswordChange={m.setDevLoginPassword}
        onCancel={() => {
          if (m.devLoginBusy) return;
          m.setDevLoginOpen(false);
        }}
        onSubmit={() => void m.submitDevLogin()}
      />

      <LeadMergeConflictModal
        pending={
          m.mergeConflict.pending
            ? {
                mergeResult: m.mergeConflict.pending.mergeResult,
                source: m.mergeConflict.pending.source,
              }
            : null
        }
        onResolve={m.mergeConflict.resolve}
        onCancel={m.mergeConflict.cancel}
      />
    </>
  );
}
